import React, { useState } from "react";
import { Link } from "react-router-dom";
import Rodal from "rodal";

// include styles
import "rodal/lib/rodal.css";

import Header from "../../components/Header";
import CourseHeader from "./components/CourseHeader";
import Outline from "./components/Outline";

import Modal from "../../components/Modal";

import "./coursepage.styles.css";
import TextInput from "../../components/TextInput";
import Textarea from "../../components/Textarea";

const CoursePage = () => {
  const [isRequestAccessVisible, setRequestAccess] = useState(false);

  const toggleVisibility = () => {
    setRequestAccess(!isRequestAccessVisible);
  };

  return (
    <section className="course__wrapper">
      <Header />
      <CourseHeader />
      <section className="course__content">
        <section class="course__content--manuals">
          <CourseDescription />
          <Outline />
        </section>
        <section class="course__content--details">
          <TagsContent onClick={toggleVisibility} />
        </section>
      </section>

      <Modal
        visible={isRequestAccessVisible}
        title="Request Access"
        btnTitle="Request Access"
        onClose={toggleVisibility}
        btnClick={() => console.log("working")}
      >
        <RequestAccessContent />
      </Modal>
    </section>
  );
};

const CourseDescription = () => {
  return (
    <section className="course__description">
      <h1 className="title">How to get started with klen</h1>
      <p>
        The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum
        dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
        quis nostrud exercitation ullamco laboris num."The standard Lorem Ipsum
        passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur
        adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
        magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris num."The standard Lorem Ipsum passage, used since the 1500s
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris num."The standard
        Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet,
        consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
        exercitation ullamco laboris num."
      </p>
    </section>
  );
};

const TagsContent = ({ onClick }) => {
  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const onHandleModal = () => {
    setVisible(false);
    setModalVisible(!modalVisible);
  };

  return (
    <>
      <h6>Tags</h6>
      <div className="course__content--tags">
        <span className="main--tag">Design</span>
        <span className="blue--tag">UX</span>
        <span className="green--tag">Product</span>
        <span className="pink--tag">Product owner</span>
      </div>
      <div className="release--date">
        <h6>Release date</h6>
        <span>25-01-2021</span>
      </div>
      <div className="actions d-flex flex-column">
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711C15.3166 7.09763 14.6834 7.09763 14.2929 6.70711L13 5.41421V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V5.41421L9.70711 6.70711C9.31658 7.09763 8.68342 7.09763 8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289L11.2929 2.29289ZM4 11C4 9.89543 4.89543 9 6 9H8C8.55228 9 9 9.44772 9 10C9 10.5523 8.55228 11 8 11H6V20H18V11H16C15.4477 11 15 10.5523 15 10C15 9.44772 15.4477 9 16 9H18C19.1046 9 20 9.89543 20 11V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V11Z"
              fill="#0D0D0D"
            />
          </svg>
          Share course
        </span>
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C12.5523 2 13 2.44772 13 3V13.5858L15.2929 11.2929C15.6834 10.9024 16.3166 10.9024 16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L11 13.5858V3C11 2.44772 11.4477 2 12 2ZM5 17C5.55228 17 6 17.4477 6 18V20H18V18C18 17.4477 18.4477 17 19 17C19.5523 17 20 17.4477 20 18V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V18C4 17.4477 4.44772 17 5 17Z"
              fill="#0D0D0D"
            />
          </svg>
          Download student report
        </span>

        <div className="course__mode">
          <button onClick={() => setVisible(!visible)}>
            Start course
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 19.2131V4.63453C4 3.88718 4.7899 3.40393 5.45529 3.74418L18.414 10.3708C19.109 10.7262 19.147 11.7052 18.4817 12.1135L5.52302 20.0654C4.85671 20.4743 4 19.9949 4 19.2131Z"
                  fill="#FBFBFB"
                />
              </svg>
            </span>
          </button>
          <div
            className={
              visible
                ? "course__mode--selection is--visible"
                : "course__mode--selection"
            }
          >
            <div className="course__mode--option" onClick={onHandleModal}>
              <h6>Multiplayer session</h6>
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4ZM4 8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8C16 11.3137 13.3137 14 10 14C6.68629 14 4 11.3137 4 8ZM16.8284 3.75736C17.219 3.36683 17.8521 3.36683 18.2426 3.75736C20.5858 6.1005 20.5858 9.8995 18.2426 12.2426C17.8521 12.6332 17.219 12.6332 16.8284 12.2426C16.4379 11.8521 16.4379 11.219 16.8284 10.8284C18.3905 9.26633 18.3905 6.73367 16.8284 5.17157C16.4379 4.78105 16.4379 4.14788 16.8284 3.75736ZM17.5299 16.7575C17.6638 16.2217 18.2067 15.8959 18.7425 16.0299C20.0705 16.3618 20.911 17.2109 21.3944 18.1778C21.8622 19.1133 22 20.1571 22 21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21C20 20.3429 19.8878 19.6367 19.6056 19.0722C19.339 18.5391 18.9295 18.1382 18.2575 17.9701C17.7217 17.8362 17.3959 17.2933 17.5299 16.7575ZM6.5 18C5.24054 18 4 19.2135 4 21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21C2 18.3682 3.89347 16 6.5 16H13.5C16.1065 16 18 18.3682 18 21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21C16 19.2135 14.7595 18 13.5 18H6.5Z"
                    fill="#0D0D0D"
                  />
                </svg>
              </span>
            </div>
            <div className="course__mode--option" onClick={onHandleModal}>
              <h6>Single-player session</h6>
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4ZM6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8ZM8 18C6.34315 18 5 19.3431 5 21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21C3 18.2386 5.23858 16 8 16H16C18.7614 16 21 18.2386 21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21C19 19.3431 17.6569 18 16 18H8Z"
                    fill="#0D0D0D"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <JoinCourseModal visible={modalVisible} onClose={onHandleModal} />
      </div>
    </>
  );
};

const RequestAccessContent = () => {
  return (
    <section className="">
      <div className="w--full mt--24">
        <TextInput
          label="Name"
          placeholder="John smith"
          type="text"
          name="name"
        />
      </div>
      <div className="w--full mt--24">
        <TextInput
          label="Email"
          placeholder="johnsmith@gmail.com"
          type="email"
          name="email"
        />
      </div>

      <div className="w--full mt--24">
        <Textarea
          label="Message (optional)"
          placeholder="johnsmith@gmail.com"
          type="email"
          name="email"
        />
      </div>
    </section>
  );
};

export const JoinCourseModal = ({ visible, onClose }) => {
  return (
    <Rodal visible={visible} showCloseButton={false} width={672}>
      <div className="joincourse__modal">
        <header>
          <span onClick={onClose}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                fill="#C3C3C3"
              />
            </svg>
          </span>
        </header>
        <main>
          <h6>How to build an inclusive team</h6>
          <p>
            Under your HR team’s leadership, your company has recruited a
            diverse workforce that includes a range of ages, ethnicities,
            religions and worldviews.{" "}
          </p>
          <Link to="/register" className="default--btn">Sign up</Link>
          <Link to="/login" className="ghost--btn">Already a user? sign in</Link>
        </main>
      </div>
    </Rodal>
  );
};

export default CoursePage;
